import { apiToken, postmanUrl } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";


export default (axios) => ({

  getApiTokenList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(apiToken.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getPostmanUrl() {
    return new Promise((resolve, reject) => {
      axios
        .get(postmanUrl.geturl)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  createApiTokenObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${apiToken.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  
  regenerateApiTokenObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${apiToken.regenerate}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
})